var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuquetOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3995 9.58882C25.7745 4.66257 21.192 1.35882 15.9782 1.30632C15.1745 1.40382 14.3532 1.43132 13.5707 1.61382C8.63447 2.78257 5.41322 5.83507 4.32072 10.7701C3.22822 15.7051 4.87197 19.8438 8.85697 22.9751C10.982 24.6413 12.7832 26.5663 14.162 28.8863C14.397 29.2788 14.617 29.6826 14.877 30.0576C15.4632 30.9026 16.5407 30.9088 17.127 30.0576C17.4232 29.6313 17.6807 29.1826 17.9357 28.7251C19.2382 26.4226 20.9857 24.5401 23.1245 22.9751C25.1636 21.4847 26.6765 19.385 27.4449 16.9791C28.2132 14.5731 28.1973 11.9852 27.3995 9.58882Z",
    fill: "url(#paint0_linear_696_14447)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84613 12.9846L11.3846 12.0615C12.3323 11.4954 13.5138 11.4954 14.4615 12.0615C15.4092 12.6277 16.5907 12.6277 17.5384 12.0615C18.4861 11.4954 19.6677 11.4954 20.6154 12.0615L22.1538 12.9846",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84613 7.32307L11.3846 8.24615C12.3323 8.81231 13.5138 8.81231 14.4615 8.24615C15.4092 7.68 16.5907 7.68 17.5384 8.24615C18.4861 8.81231 19.6677 8.81231 20.6154 8.24615L22.1538 7.32307",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84613 17.2923L11.3846 16.3692C12.3323 15.8031 13.5138 15.8031 14.4615 16.3692C15.4092 16.9354 16.5907 16.9354 17.5384 16.3692C18.4861 15.8031 19.6677 15.8031 20.6154 16.3692L22.1538 17.2923",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_696_14447",
    x1: 3.99322,
    y1: 0.803818,
    x2: 23.8682,
    y2: 23.8663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697486"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuquetOffline);
export default __webpack_public_path__ + "static/media/luquetOffline.8029e11fad336efed0a7af97c70dc393.svg";
export { ForwardRef as ReactComponent };